import { render, staticRenderFns } from "./selectSupplierAndSubBoxDialog.vue?vue&type=template&id=ada266a2"
import script from "./selectSupplierAndSubBoxDialog.vue?vue&type=script&lang=js"
export * from "./selectSupplierAndSubBoxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports